<template>
  <!-- <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in"> -->
        <v-container fluid class="pa-3">

          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-icon>people</v-icon>
                  <v-toolbar-title>Applicants Listing - {{reqRec.name}} ({{ reqRec.status }})</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" small fab :href="'req_applicants_crud?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=1&_id=&reqid=' + reqRec._id" v-on="on" 
                          :disabled="disabled_btn"
                        >
                          <v-icon>add_circle_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Add candidate</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <!-- <v-container fluid> -->
                    <v-layout row wrap>
                      <v-flex xs12>

                        <v-expansion-panel>
                          <v-expansion-panel-content class="accent">
                            <template v-slot:header>
                              <div style="font-size: medium;">Filter Panel</div>         
                            </template>

                            <v-container fluid class="pt-0">
                              <v-layout row wrap>
                                <v-flex class="text-xs-right">
                                  <v-btn color="orange" small fab @click="selected_filter.push({field:'', value:'',type:''})"><v-icon color="white">add</v-icon></v-btn>
                                  <v-btn color="green" @click="refreshData()">GENERATE NOW</v-btn>
                                  <v-btn color="cyan lighten-1" @click="selected_filter=[], refreshData()">RESET FILTER</v-btn>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex>
                                  <v-card>
                                    <v-card-text v-if="selected_filter.length > 0">
                                      <!-- <v-container> -->
                                        <v-layout row wrap
                                          v-for="(item,i) in selected_filter"
                                          :key="i"
                                        >                                
                                          <v-flex xs12 md5>
                                            <v-select
                                              v-model="selected_filter[i].field"
                                              :items="get_filterable_columns"
                                              @change="d_onchange(selected_filter[i])"
                                              clearable
                                              item-text="text"
                                              item-value="value"
                                              label="select field"
                                            ></v-select>
                                          </v-flex>
                                          <v-flex xs12 md1 class="text-md-center">
                                            contains
                                          </v-flex>
                                          <v-flex xs12 md5>
                                            <v-text-field
                                              v-model="selected_filter[i].value"
                                              label="your text"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex xs12 md1>
                                            <v-layout justify-space-around class="mb-2">
                                              <span class="group pa-2">
                                                <v-btn color="red" small fab @click="selected_filter.splice(i,1)" :disabled="false"><v-icon color="white">clear</v-icon></v-btn>
                                                
                                              </span>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                      <!-- </v-container> -->
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-data-table
                          :headers="table.headers"
                          :items="table.items"
                          :loading="table.loading"
                          must-sort
                          :pagination.sync="table.pagination"
                          :rows-per-page-items="table.rows_per_page_items"
                          :total-items="table.total_items"
                          class="elevation-1"
                        >
                          <v-progress-linear color="blue" indeterminate>
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item._id }}</td>
                            <td class="pa-1">{{ props.item.name }}</td>
                            <td class="pa-1">{{ props.item.email[0] }}</td>
                            <td class="pa-1">{{ props.item.contact_no }}</td>
                            <td class="pa-1">
                              <span v-if="props.item.email_invi==1">Yes</span>
                              <span v-else>No</span>
                            </td>
                            <!-- <td class="pa-1">
                              <a :href="'#?pageid=xxx&_id=' + props.item._id">{{ getCount(props.item.email_log) }}</a>
                            </td> -->
                            <td class="pa-1" v-html="populate_form_list_items(props.item.forms)"></td>
                            <td class="pa-1">
                              <pre v-html="props.item.remark"></pre>
                            </td>
                            <td class="pa-1">{{ props.item.created_by }}</td>
                            <td class="pa-1">
                              {{
                              epoch2localedatetime(props.item.created)
                              }}
                            </td>
                            <td class="pa-1">{{ props.item.modified_by }}</td>
                            <td class="pa-1">
                              {{
                              epoch2localedatetime(props.item.modified)
                              }}
                            </td>
                            <td class="pa-1">{{ props.item.status }}</td>
                            <td class="pa-1">
                              <v-menu bottom left offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon v-on="on">
                                    <v-icon color="primary">more_vert</v-icon>
                                  </v-btn>
                                </template>
                                
                                <v-list dense class="pa-0">
                                  <v-list-tile :href="'req_applicants_crud?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=' + props.item.email_invi + '&_id=' + props.item._id + '&reqid=' + reqRec._id" v-if="username">
                                    <v-list-tile-action><v-icon small left>edit</v-icon></v-list-tile-action>
                                    <v-list-tile-title>Edit / View</v-list-tile-title>
                                  </v-list-tile>
                                  <a ></a>
                                  <v-list-tile :href="'req_application_forms?uuid=d5b82c80-afc2-489a-81a2-d949ad139891&_id=' + props.item._id + '&email_invi=' + props.item.email_invi + '&reqid=' + reqRec._id" v-if="username">
                                    <v-list-tile-action><v-icon small left>summarize</v-icon></v-list-tile-action>
                                    <v-list-tile-title>View Forms</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile :href="'req_log?uuid=17039181-95cf-4351-9100-9758cdd16d0f&Lev=email&Lso=' + props.item._id" v-if="props.item.email_invi == 1">
                                    <v-list-tile-action><v-icon small left>list</v-icon></v-list-tile-action>
                                    <v-list-tile-title>Email Log</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile :href="'req_log?uuid=17039181-95cf-4351-9100-9758cdd16d0f&Lev=&Lso=' + props.item._id">
                                    <v-list-tile-action><v-icon small left>list</v-icon></v-list-tile-action>
                                    <v-list-tile-title>Activity Log</v-list-tile-title>
                                  </v-list-tile>
                                </v-list>
                              </v-menu>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  <!-- </v-container> -->
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      <!-- </v-slide-y-transition>

    </v-flex>
  </v-layout> -->

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
// import comm from "../../functions/communication.api";
import query_builder from "../../functions/query.builder";

export default {
  name: "req_applicants_listing",
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      reqStatus_option: "",
      reqRec: {},
      showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      selected_filter: [],
      rules: {
				required: (value) => !!value || "This field required.",
				greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
			},
      table: {
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [
          {
            text: "#ID",
            class: "pa-1 pl-3",
            value: "_id",
            filterable: true,
            sortable: true,
            data_type: "String"
          },
          {
            text: "Name",
            class: "pa-1",
            value: "name",
            filterable: true,
            sortable: true,
            data_type: "String"
          },
          {
            text: "Email",
            class: "pa-1",
            value: "email",
            filterable: true,
            sortable: false,
            data_type: "String"
          },
          {
            text: "Contact No",
            class: "pa-1",
            value: "contact_no",
            filterable: true,
            sortable: false,
            data_type: "String"
          },
          {
            text: "Email Invite",
            class: "pa-1",
            value: "email_invi",
            filterable: false,
            sortable: true,
            data_type: "Number"
          },
          // {
          //   text: "Email Log",
          //   class: "pa-1",
          //   value: "email_log_len",
          //   filterable: false,
          //   sortable: true,
          //   data_type: "Number"
          // },
          {
            text: "Forms",
            class: "pa-1",
            value: "forms_len",
            filterable: false,
            sortable: true,
            data_type: "Number"
          },
          {
            text: "Remark",
            class: "pa-1",
            value: "remark",
            filterable: true,
            sortable: true,
            data_type: "String"
          },
          {
            text: "Created By",
            // align: "left",
            class: "pa-1",
            value: "created_by",
            filterable: true,            
            sortable: true,
            data_type: "String"
          },
          {
            text: "Created DateTime",
            // align: "left",
            class: "pa-1",
            value: "created",
            filterable: false,            
            sortable: true,
            data_type: "Date"
          },
          {
            text: "Modified By",
            // align: "left",
            class: "pa-1",
            value: "modified_by",
            filterable: true,            
            sortable: true,
            data_type: "String"
          },
          {
            text: "Modified DateTime",
            // align: "left",
            class: "pa-1",
            value: "modified",
            filterable: false,            
            sortable: true,
            data_type: "Date"
          },
          {
            text: "Status",
            // align: "left",
            class: "pa-1",
            value: "status",
            filterable: true,            
            sortable: true,
            data_type: "String"
          }
        ],
				items: [],
				total_items:0,
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 10,
					sortBy: "_id",
					totalItems: 100
				},
      },
      status_option: [],
      selected: { // to update
				_id: "",
        name: "",
        email: "",
        contact_no: "",
        email_invi: "",
        remark: "",
        g_status_id: ""
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    },
    disabled_btn() {
      var value = false;

      try {
        if (this.reqRec.g_status_id == this.reqStatus_option[2]._id) {
          value = true;
        }  
      } catch (error) {}
      
      return value;
    }
  },
  watch: {
    "table.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    },
  },
  async mounted() {
    common.App.set_page_title("mySuite: Applicants");

    this.username = auth.getUsername();
		this.status_option = await common.App.arango_app_selections("requisition", "applicants_status");
    this.reqStatus_option = await common.App.arango_app_selections("requisition", "status");

		var qb = new query_builder.QueryBuilder();
		qb.Table = "requisition_listing";
    // qb.Select = [{value:"name"},{value:"g_status_id"}];

    let rule = new query_builder.Rule();
    // only show selected requisition_id
    rule
      .field("_id")
      .operator(query_builder.A_STR_OPERATOR.EQUAL)
      .value(common.App.getQueryString("reqid"));
    qb.Where.rules.push(rule);

    qb.Offset = 1;
    
		let res = await common.wBackEndComm.PostData("process_arango_qb/", qb);
		res = res.data;
		if (res.Status == 1) {
      this.reqRec = res.Body[0].records[0];
		} else {
			common.wMsgBox.Error(res.Description);
		}
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    epoch2localedatetime: common.App.epoch2LocaleDatetime,
    populate_form_list_items(arr) {
      let len = arr.length;
      let temp = "";
      
      if (len>0) {
        temp = "<ul>";
        for (let j=0, n=len; j<n; j++) {
          
          let status = arr[j].info.status==0?" (New)":" (Done)"
          temp += "<li>" + arr[j].info.form_name + status + "</li>";
          
        }
        temp += "</ul>";
      }

      return temp;
    },
    // getCount(rec){
    //   let result = null;
    //   result = rec.length;
    //   return result;
    // },
    d_onchange(ind){
      var temp = this.table.headers.find(el => el.value == ind.field);
      ind.type = temp.data_type;
    },
    async refreshData() {
      common.App.loader.show(this);
			// this.table.loading = true;
			var qb = new query_builder.QueryBuilder();

			qb.Table = "requisition_applicants_listing";
			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;

			// must check sortBy before push in order array
			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					}
				];
			}

      let rule = new query_builder.Rule();
      // only show selected requisition_id
      rule
        .field("req_id")
        .operator(query_builder.A_STR_OPERATOR.EQUAL)
        .value(common.App.getQueryString("reqid"));
      qb.Where.rules.push(rule);


      let filter_len = this.selected_filter.length;

      if (filter_len>0) {
        for (let i =0; i<filter_len; i++) {

          switch(this.selected_filter[i].type) {
            case "String":
              rule = new query_builder.Rule();
              rule
                .field(this.selected_filter[i].field)
                .operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
                .value(this.selected_filter[i].value);
              break;
  
            case "Number":
              break;
  
            case "Date":
              break; 
          }
          qb.Where.rules.push(rule);
        }
      }

			var res = await common.wBackEndComm.PostData("process_arango_qb/", qb);
			res = res.data;
			if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;
			} else {
				common.wMsgBox.Error(res.Description);
			}

			// this.table.loading = false;
      common.App.loader.hide(this);
    },
    viewMenu() {
      this.showMenu = true;
    },
    getCurrentStatusOrder(cur_status_id) {
      var val = null;      
      var obj = this.status_option.find(function(el){
        return el._id==cur_status_id;
      });

      if (obj){
        val = obj.order;
      }

      return val;
    }
  }
};
</script>

<style>

</style>
